export const THERMAL_PRINT_MODES = {
  full: {
    label: "Full bill",
    hint: "Qty, rate, line amount & payment totals",
  },
  hideItemPrices: {
    label: "Hide item rate",
    hint: "Product, qty & line amount; per-item price hidden",
  },
  qtyOnly: {
    label: "Qty only",
    hint: "No prices anywhere on receipt",
  },
};

const ThermalPrintModeSelect = ({ value, onChange, compact = false }) => {
  if (compact) {
    return (
      <div className="w-full">
        <select
          id="thermal-print-mode-select"
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          aria-label="Print format"
          className="w-full h-8 border border-line rounded-md px-2 text-[11px] font-semibold bg-card text-ink outline-none focus:border-main focus:ring-1 focus:ring-main/15"
        >
          {Object.entries(THERMAL_PRINT_MODES).map(([mode, { label }]) => (
            <option key={mode} value={mode}>
              {label}
            </option>
          ))}
        </select>
      </div>
    );
  }

  return (
    <fieldset className="m-0 min-w-0 space-y-2 border-0 p-0">
      <legend className="sr-only">Thermal print mode</legend>
      {Object.entries(THERMAL_PRINT_MODES).map(([mode, { label, hint }]) => (
        <label
          key={mode}
          className="flex items-start gap-2.5 p-3 rounded-lg border border-line bg-card cursor-pointer has-[:checked]:border-main has-[:checked]:bg-brandSoft transition-colors"
        >
          <input
            type="radio"
            name="thermal-print-mode"
            value={mode}
            checked={value === mode}
            onChange={() => onChange?.(mode)}
            className="mt-0.5 h-4 w-4 accent-main"
          />
          <span className="text-sm text-left">
            <span className="font-semibold text-ink block">{label}</span>
            <span className="text-xs text-muted">{hint}</span>
          </span>
        </label>
      ))}
    </fieldset>
  );
};

export default ThermalPrintModeSelect;
